export default __webpack_public_path__ + "static/media/video-long.4fa7a441.mp4";